import { AfterViewInit, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'fury-removable-attachment',
  templateUrl: './removable-attachment.component.html',
  styleUrls: ['./removable-attachment.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RemovableAttachmentComponent implements AfterViewInit {

  @Input() report_id: number = null;
  @Input() attachment_id: number = null;
  @Input() attachment: File = null;
  @Input() filename: string = null;
  @Input() size: number = null;

  @Output() destroy: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostBinding('className') className = 'fury-removable-attachment';

  constructor() {
  }

  ngAfterViewInit() {
  }

  removeAttachment() {
    this.destroy.emit(true);
  }
}
